enum ReservaHemocomponentEnum {
  ConcentradoHemacias = 'ConcentradoHemacias',
  ConcentradoPlaquetas = 'ConcentradoPlaquetas',
  PlasmaFrescoCongelado = 'PlasmaFrescoCongelado',
  Crioprecipitado = 'Crioprecipitado',
  TipagemSanguineaABORHPAI = 'TipagemSanguineaABORHPAI',
  SemReserva = 'SemReserva',
}

export default ReservaHemocomponentEnum
